<emob-modal-card>
  <emob-modal-card-header></emob-modal-card-header>
  <emob-modal-card-content>
    <div class="pacman-wrapper">
      <div class="pacman-grid"></div>
      <h3>Score:<span id="pacman-score">0</span></h3>
    </div>
  </emob-modal-card-content>
</emob-modal-card>
